import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  DeleteAddress,
  getAddressesLoadingId,
  getAddressesPageInfo,
  getCustomer,
  getCustomerVatNumber,
  getLoadingAsDefaultAddress,
  getOrderedAddresses,
  LoadMoreAddresses,
  SetDefaultAddress,
} from 'src/app/shop';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';
import { cleanAddressId } from 'src/app/shop/services';
import { DialogConfirmComponent } from 'src/app/core/components/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-account-profile',
    templateUrl: './account-profile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountProfileComponent implements OnInit {
  private store = inject(Store);
  private lang = inject(LanguageService);
  private dict = new FromDictionaryPipe(this.lang);
  private dialog = inject(MatDialog);

  prefix = 'profiel';
  customer$: any = this.store.selectSignal(getCustomer);
  addresses$ = this.store.selectSignal(getOrderedAddresses);
  loadingAsDefaultAddress$ = this.store.selectSignal(getLoadingAsDefaultAddress);
  loadingUpdatesAddressId$ = this.store.selectSignal(getAddressesLoadingId);
  addressPage$ = this.store.selectSignal(getAddressesPageInfo);

  breadcrumbs: Breadcrumb[] = [];

  addressUpdateState$ = computed(() => {
    const defaultId = this.loadingAsDefaultAddress$();
    const updateId = this.loadingUpdatesAddressId$();

    return {
      loadingId: defaultId || updateId || '',
      action: !!defaultId ? 'setDefault' : !!updateId ? 'isDeleting' : '',
    };
  });

  customerVatNumber$ = this.store.selectSignal(getCustomerVatNumber);

  constructor() {}

  ngOnInit(): void {
    this.breadcrumbs = [
      {
        label: this.dict.transform(`account-menu-titel`),
        routerLink: ['/account'],
      },
    ];
  }

  loadMoreAddresses() {
    this.store.dispatch(LoadMoreAddresses());
  }

  compareAddressIds(a?: string, b?: string) {
    if (!a || !b) {
      return false;
    }
    return cleanAddressId(a) === cleanAddressId(b);
  }

  cleanAddressId(a: string) {
    return cleanAddressId(a);
  }

  deleteAddress(id: string) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        title: 'Weet u het zeker?',
        text: 'Weet je het zeker dat je dit adres wilt verwijderen?',
        actionLabels: {
          proceed: 'Verwijderen',
        },
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.store.dispatch(DeleteAddress({ id }));
      }
    });
  }
  handleAddressCardAction(action: { action: string; id: string }) {
    switch (action.action) {
      case 'delete':
        this.deleteAddress(action.id);
        break;
      case 'setDefault':
        this.store.dispatch(SetDefaultAddress({ id: action.id }));
        break;

      default:
        break;
    }
  }
}
